import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { NgRatingBarModule } from 'ng-rating-bar';
import { MoveContactComponent, MoveContactDialog } from './move-contact/move-contact.component';

import {
	ContactDetailsModalComponent,
	ContactDialogComponent,
} from './contact-details-modal/contact-details-modal.component';
import {
	CarrierContactsFeedbackComponent,
	FeedbackDialog,
	SelectContactDialog,
} from './carrier-contacts-feedback/carrier-contacts-feedback.component';
import { AccountMappingComponent } from './account-mapping/account-mapping.component';
import { CarrierContactsComponent } from './carrier-contacts/carrier-contacts.component';
import { CarrierContactActionsComponent } from './carrier-contact-actions/carrier-contact-actions.component';
import { AddContactComponent, AddContactFormDialog } from './add-contact/add-contact.component';

const maskConfig: Partial<IConfig> = {};

const components = [
	ContactDetailsModalComponent,
	ContactDialogComponent,
	CarrierContactsFeedbackComponent,
	AccountMappingComponent,
	CarrierContactsComponent,
	CarrierContactActionsComponent,
	MoveContactComponent,
	MoveContactDialog,
	AddContactComponent,
	AddContactFormDialog,
	SelectContactDialog,
	FeedbackDialog,
];

@NgModule({
	declarations: [components],
	imports: [
		CoreModule,
		SharedModule,
		CommonModule,
		NgRatingBarModule,
		NgxMaskDirective,
		NgxMaskPipe,
	],
	exports: [...components],
	providers: [provideEnvironmentNgxMask(maskConfig)],
})
export class ContactDetailsModule {}
